module.exports = __webpack_public_path__ + "img/safe3.924f03d2.png";